export enum McsisRole {
  Administrator,
  Doctor,
  Participant,
  Pharmacist,
}
